<template>
  <div>
    <div style="height: 40px;margin: 10px 40px">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
      <div class="add-open-btn" v-if="indexActive === 8 || indexActive === 2 || indexActive === 9" @click="addOpen()">
        <strong>+</strong>
      </div>
    </div>
    <!--  SOS呼叫号码  -->
    <div v-if="indexActive === 0" style="margin: 0 40px">
      <div class="sos-phone">
        <el-row>
          <el-col :span="8"><span>电话一&nbsp;&nbsp;</span><el-input type="number" style="width: 210px" placeholder="请输入号码" v-model="sosPhone.phone1" clearable></el-input></el-col>
<!--          <el-col :span="8"><span>&nbsp;&nbsp;&nbsp;电话二&nbsp;&nbsp;</span><el-input type="number" style="width: 210px" placeholder="请输入号码" v-model="sosPhone.phone2" clearable></el-input>&nbsp;&nbsp;&nbsp;</el-col>-->
<!--          <el-col :span="8"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话三&nbsp;&nbsp;</span><el-input type="number" style="width: 210px" placeholder="请输入号码" v-model="sosPhone.phone3" clearable></el-input></el-col>-->
        </el-row>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitSOSphone()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  跌倒设置  -->
    <div v-if="indexActive === 1" style="margin: 0 40px">
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="fall-down">
            <span>跌倒功能&nbsp;&nbsp;</span>
            <el-radio-group v-model="fallDownRadio">
              <el-radio :label="0">关闭</el-radio><el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="fall-down"><span>待定值&nbsp;&nbsp;</span><el-input type="number" style="width: 210px" placeholder="0 ~ 100" v-model="fallDown" clearable></el-input></div>
        </el-col>
      </el-row>
      <div style="height: 60px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitFallDown()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  闹钟提醒  -->
    <div v-if="indexActive === 2" style="margin: 0 40px">
      <div style="max-height: 400px;">
        <div style="height: 10px"></div>
        <el-table :data="clockList" border style="width: 100%;margin-top: 10px" highlight-current-row size="mini">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column label="提醒周期" min-width="135" align="center">
            <template slot-scope="scope">
              <span>{{showClockPeriod(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="提醒时间" min-width="135" align="center"></el-table-column>
          <el-table-column label="提醒内容" min-width="135" align="center">
            <template slot-scope="scope">
              <span>{{showClockContent(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="130">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editClock(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delClock(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 60px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitAlarmClock()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  语音设置  -->
    <div v-if="indexActive === 3" style="margin: 0 40px">
      <el-row class="sos-phone">
        <el-col :span="8">
          <div style="float: left;line-height: 40px">
            <span style="color:#333333;">自动播放&nbsp;&nbsp;</span>
            <el-radio-group v-model="voiceForm.title">
              <el-radio :label="0">关闭</el-radio><el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="16">
          <div style="float: left;width: 90px;line-height: 40px">
            <span style="color: red">*</span><span>通知内容&nbsp;&nbsp;</span>
          </div>
          <div style="float: left;width: calc(100% - 90px)">
            <el-input type="textarea" :rows="2" placeholder="请输入通知内容" v-model="voiceForm.text" clearable></el-input>
          </div>
          <div style="clear:both;"></div>
        </el-col>
      </el-row>
      <div style="margin-top: 10px;max-height: 300px;overflow-y: auto">
        <el-table :data="fallDownTable" border style="width: 100%;margin-top: 10px" highlight-current-row size="mini">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="text" label="通知内容" min-width="120" align="center"></el-table-column>
          <el-table-column prop="username" label="发送人" min-width="65" align="center"></el-table-column>
          <el-table-column label="推送状态" min-width="70" align="center">
            <template slot-scope="scope">
              <strong style="color: red" v-if="scope.row.tag === 1">已推送</strong>
              <strong style="color: green" v-else-if="scope.row.tag === 2">已阅读</strong>
              <span v-else>{{scope.row.tag}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="push_tm" label="推送时间" min-width="135" align="center"></el-table-column>
          <el-table-column label="阅读时间" min-width="135" align="center">
            <template slot-scope="scope">
              <span>{{showReadTm(scope.row)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
          </el-pagination>
        </div>
      </div>
      <div style="height: 60px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitVoice()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  蓝牙功能  -->
    <div v-if="indexActive === 4" style="margin: 0 40px">
      <div style="height: 40px">
        <span style="color:#333333;">蓝牙&nbsp;&nbsp;</span>
        <el-radio-group v-model="bluetooth">
          <el-radio :label="0">关闭</el-radio><el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </div>
      <div class="sos-phone">
        <el-row>
          <el-col :span="8">
            <span>扫描间隔&nbsp;&nbsp;</span>
            <el-input type="number" style="width: 210px" placeholder="请输入" v-model="bluetoothObj.interval">
              <template slot="append">秒</template>
            </el-input>
          </el-col>
          <el-col :span="8">
            <span>&nbsp;&nbsp;扫描时长&nbsp;&nbsp;</span>
            <el-input type="number" style="width: 210px" placeholder="请输入" v-model="bluetoothObj.time">
              <template slot="append">秒</template>
            </el-input>
          </el-col>
          <el-col :span="8"><span>&nbsp;&nbsp;&nbsp;扫描过滤&nbsp;&nbsp;</span><el-input style="width: 210px" placeholder="请输入" v-model="bluetoothObj.filtration" clearable></el-input></el-col>
        </el-row>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitBluetooth()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  定位设置  -->
    <div v-if="indexActive === 5" style="margin: 0 40px">
      <div style="height: 40px">
        <div :class="locationRadio === '1' ? 'btn-title-blue' : 'btn-title-gray'"><el-radio style="font-size: 18px" v-model="locationRadio" label="1">按次定位</el-radio></div>
        <div :class="locationRadio === '2' ? 'btn-title-blue' : 'btn-title-gray'"><el-radio style="font-size: 18px" v-model="locationRadio" label="2">按时间段定位</el-radio></div>
      </div>
      <div style="margin-top: 10px" v-if="locationRadio === '1'">
        <span style="color:#333333;">定位&nbsp;&nbsp;</span>
        <el-radio-group v-model="location1">
          <el-radio :label="-1">停止</el-radio><el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </div>
      <div style="margin-top: 10px" v-if="locationRadio === '2'">
        <span style="color:#333333;">定位&nbsp;&nbsp;</span>
        <el-radio-group v-model="location2">
          <el-radio :label="-1">停止</el-radio><el-radio :label="2">开启</el-radio>
        </el-radio-group>
      </div>
      <div class="sos-phone">
        <el-row style="margin-top: 15px">
          <el-col :span="24" v-if="locationRadio === '2'">
            <span>时间范围&nbsp;</span>
             <el-time-picker v-fixZoom is-range v-model="locationObj.timeDate" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
              value-format="HH:mm" style="width: 300px">
            </el-time-picker>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-col :span="8" v-if="locationRadio === '1'"><span>定位次数&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="locationObj.num" clearable></el-input></el-col>
<!--          <el-col :span="8"><span v-if="locationRadio === '1'">-->
<!--          &nbsp;&nbsp;</span><span>定位间隔&nbsp;&nbsp;</span>-->
<!--            <el-input type="number" style="width: 210px" placeholder="请输入" v-model="locationObj.time">-->
<!--              <template slot="append">秒</template>-->
<!--            </el-input>-->
<!--          </el-col>-->
          <el-col :span="8"><span v-if="locationRadio === '1'">
          &nbsp;&nbsp;</span><span>定位间隔&nbsp;&nbsp;</span>
            <el-select v-fixZoom style="width: 180px" v-model="time" placeholder="请选择" @change="changeTime">
              <el-option v-for="item in timeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
<!--          <el-col :span="8">-->
<!--            <span>&nbsp;&nbsp;定位模式&nbsp;&nbsp;</span>-->
<!--            <el-select v-fixZoom style="width: 210px" v-model="locationObj.selectModel" placeholder="请选择">-->
<!--              <el-option v-for="item in modelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
        </el-row>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitLocation()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  室内定位  -->
    <div v-if="indexActive === 6" style="margin: 0 40px">
      <div style="height: 35px">
        <span style="color:#333333;">定位&nbsp;&nbsp;</span>
        <el-radio-group v-model="indoor">
          <el-radio :label="-3">停止</el-radio><el-radio :label="3">开启</el-radio>
        </el-radio-group>
      </div>
      <div class="sos-phone">
        <el-row>
          <el-col :span="8">
            <span>定位模式&nbsp;</span>
            <el-select v-fixZoom style="width: 210px" v-model="indoorObj.model" placeholder="请选择">
              <el-option v-for="item in locationModelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span>&nbsp;&nbsp;过滤类型&nbsp;</span>
            <el-select v-fixZoom style="width: 210px" v-model="indoorObj.type" placeholder="请选择">
              <el-option v-for="item in typeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8"><span>&nbsp;&nbsp;&nbsp;过滤字符&nbsp;&nbsp;</span><el-input style="width: 210px" placeholder="请输入" v-model="indoorObj.symbol" clearable></el-input></el-col>
        </el-row>
      </div>
      <div class="sos-phone" style="margin-top: 15px">
        <el-row>
          <el-col :span="8">
            <span>扫描间隔&nbsp;&nbsp;</span>
            <el-input type="number" style="width: 210px" placeholder="请输入" v-model="indoorObj.interval">
              <template slot="append">秒</template>
            </el-input>
          </el-col>
          <el-col :span="8">
            <span>&nbsp;&nbsp;超时时长&nbsp;&nbsp;</span>
            <el-input type="number" style="width: 210px" placeholder="请输入" v-model="indoorObj.time">
              <template slot="append">秒</template>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitIndoor()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  录音上传  -->
    <div v-if="indexActive === 7" style="margin: 0 40px">
      <div class="sos-phone">
        <el-row>
          <el-col :span="8">
            <span>录音时长&nbsp;&nbsp;</span>
            <!--          <el-input style="width: 180px" placeholder="请输入录音时长" v-model="record.duration" clearable></el-input>-->
            <el-input type="number" max="300" style="width: 210px" placeholder="请输入" v-model="recordObj.duration" oninput="if(value > 300) value = 300;if(value < 0) value = 0;">
              <template slot="append">秒</template>
            </el-input>
          </el-col>
          <el-col :span="16">
            <div style="margin-top: 20px">
              <span style="color: red;font-size: 13px">提示：建议不超过 20 秒，最长 300 秒</span>
            </div>
          </el-col>
        </el-row>
        <div style="margin-top: 10px;max-height: 300px;overflow-y: auto">
          <el-table ref="table" :data="recordTable" border style="width: 100%;margin-top: 10px" highlight-current-row size="mini">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="create_tm" label="录音时间" min-width="65" align="center"></el-table-column>
            <el-table-column label="录音文件名" min-width="120" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.uploadtag === 0">等待设备上传文件</span>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="" width="45">
              <template slot-scope="scope">
                <i v-if="scope.row.uploadtag === 1"
                   :title="!scope.row.isRecord ? '播放' : '停止'"
                   :class="!scope.row.isRecord ? 'el-icon-video-play' : 'el-icon-video-pause'"
                   :style="!scope.row.isRecord ? 'cursor: pointer; font-size: 18px;color: blue' : 'cursor: pointer; font-size: 18px;color: red'"
                   @click="!scope.row.isRecord ? playRecord(scope.row) : stopRecord(scope.row)">
                </i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitRecord()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  通讯录设置  -->
    <div v-if="indexActive === 8" style="margin: 0 40px">
      <div style="max-height: 400px;">
        <div style="height: 10px"></div>
        <div v-if="phoneList === null || phoneList.length === 0" style="height: 150px;line-height: 150px;font-size: 20px;text-align: center">
          <span>暂无电话</span>
        </div>
        <div v-else style="max-height: 300px;overflow-y: auto;">
          <div class="box-card" v-for="item in phoneList" :key="item.no">
            <div class="img-left">
              <img :src="getSrcUri(item.uri)"/>
            </div>
            <div class="body-center">
              <div style="height: 15px"></div>
              <div style="height: 30px;font-size: 20px;color: #333333">
                <span>{{item.name}}</span>
              </div>
              <div style="height: 20px;color: #666666">
            <span>
              <img style="vertical-align: text-top;" src="../../../assets/tel/telephone_phone.png">
              <span>{{item.phone}}</span>
            </span>
              </div>
              <div style="height: 20px;color: #666666">
            <span>
              <img style="vertical-align: text-top;" src="../../../assets/tel/telephone_im.png">
              <span>{{item.im_num}}</span>
            </span>
              </div>
            </div>
            <div class="btn-right">
              <el-row>
                <el-col :span="12">
                  <div class="del-sub-red" @click="delPhone(item)">
                    <el-row>
                      <el-col :span="10" style="height: 30px;text-align: right">
                        <img style="margin-top: 6px" src="../../../../static/subDevice/son_btn_delete.png">
                      </el-col>
                      <el-col :span="14" style="height: 30px;line-height: 30px;color: white">
                        <span style="margin-left: 5px">删除</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="edit-sub-blue" @click="editPhone(item)">
                    <el-row>
                      <el-col :span="10" style="height: 30px;text-align: right">
                        <img style="margin-top: 6px" src="../../../../static/subDevice/son_btn_edit.png">
                      </el-col>
                      <el-col :span="14" style="height: 30px;line-height: 30px;color: white">
                        <span style="margin-left: 5px">编辑</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 60px;margin: 30px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitPhoneBook()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  定位  -->
    <div v-if="indexActive === 9" style="margin: 0 30px;height: 300px">
      <require-location :listObj="listObj" :locationCommand="locationCommand" ref="locationRef" @getCommandData="getDeviceCommand"></require-location>
    </div>
    <el-dialog :visible.sync="addEditPhoneShow" v-if="addEditPhoneShow" width="650px" :show-close="true" :close-on-click-modal="false"
      center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{addEditPhoneTitle}}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-phone :addEditPhoneObj="addEditPhoneObj" v-model="addEditPhoneShow" @getFather="getDevicePhoneBook"></add-edit-phone>
    </el-dialog>
    <el-dialog :visible.sync="addEditClockShow" v-if="addEditClockShow" width="850px" :show-close="true" :close-on-click-modal="false"
      center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{addEditClockTitle}}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-clock :addEditClockObj="addEditClockObj" v-model="addEditClockShow" @getFather="getDeviceClock"></add-edit-clock>
    </el-dialog>
  </div>
</template>

<script>
import {addvoicemsg, sendcommand, querycommand, querydevicerecord} from '../../../api/device'
import {queryvoicemessagestatusbydid} from '../../../api/voice'
import BenzAMRRecorder from 'benz-amr-recorder'
import addEditPhone from '../../systemlog/childComponents/addEditPhone'
import addEditClock from '../../systemlog/childComponents/addEditClock'
import requireLocation from './requireLocation.vue'

export default {
  name: 'listTabsCat',
  components: {addEditPhone, addEditClock, requireLocation},
  model: {
    prop: 'listShow901',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      deviceRow: {
        devicetype: 0
      },
      tabs: [],
      indexActive: 1,
      // 0、SOS呼叫号码
      sosPhone: {
        phone1: '',
        phone2: '',
        phone3: ''
      },
      // 1、跌倒设置
      fallDownRadio: 0,
      fallDown: 50,
      // 2、闹钟提醒
      clockList: [],
      addEditClockShow: false,
      addEditClockTitle: '',
      addEditClockObj: {
        isAdd: true,
        row: ''
      },
      alarmClock: {
        type: '',
        period: 'y',
        yTime: '',
        mTime: '',
        dTime: '',
        sTime: '',
        content: ''
      },
      clockPeriodModelArr: [{name: '按年', id: 'y'}, {name: '按月', id: 'm'}, {name: '按天', id: 'd'}, {name: '只提醒一次', id: 's'}],
      clockContentTypeArr: [{name: '吃药提醒', id: 'pill'}, {name: '量血压', id: 'BP'}, {name: '测体温', id: 'Temp'}, {name: '测血糖', id: 'GLU'}, {name: '体检', id: 'PE'}, {name: '其它', id: 'other'}],
      // 3、语音通知
      voiceForm: {
        imei: '',
        title: 0,
        text: '',
        push_type: 2, // 1 组织批量 2 指定设备 3 小区批量 4家庭批量 5选择人群
        push_mqtttopic: '',
        oid: 0, // push_type =1 要有值
        did: 0, // push_type =2 要有值
        cid: 0, // push_type =3 要有值
        hid: 0, // push_type =4 要有值
        device_type: 901 // 设备类型，必填，默认700
      },
      sendPersonSex: [],
      sendPersonBirthday: '',
      fallDownTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      // 4、蓝牙功能
      bluetooth: 0,
      bluetoothObj: {
        interval: '',
        time: '',
        filtration: ''
      },
      // 5、定位设置
      locationRadio: '1',
      location1: -1,
      location2: -1,
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      locationObj: {
        timeDate: '',
        num: '',
        time: '',
        selectModel: ''
      },
      modelArr: [{name: '基站', id: 1}, {name: 'wifi', id: 2}, {name: '自动高精度', id: 4}, {name: '自动最快', id: 5}],
      time: '',
      timeArr: [{name: '5分钟', id: 300}, {name: '10分钟', id: 600}, {name: '30分钟', id: 1800}, {name: '1小时', id: 3600}, {name: '2小时', id: 7200}],
      // 6、室内定位
      indoor: -3,
      indoorObj: {
        model: '',
        type: '',
        symbol: '',
        interval: '',
        time: ''
      },
      locationModelArr: [{name: 'wifi', id: 1}, {name: '蓝牙', id: 2}],
      typeArr: [{name: 'ssid', id: 1}, {name: 'mac', id: 2}],
      // 7、录音上传
      recordTable: [],
      recordObj: {
        url: '',
        fileName: '',
        duration: ''
      },
      amr: null,
      // 8、通讯录设置
      phoneList: [],
      addEditPhoneShow: false,
      addEditPhoneTitle: '',
      addEditPhoneObj: {
        isAdd: true,
        row: ''
      },
      // 9 定位
      locationCommand: ''
    }
  },
  created () {
    this.deviceRow = this.listObj.deviceRow
    // console.log(this.deviceRow)
    this.voiceForm.imei = this.deviceRow.deviceid
    this.voiceForm.did = this.deviceRow.id
    this.getTabs()
    if (this.deviceRow.devicetype === 901) {
      this.getVoiceByDid()
      this.getRecordByDid()
    }
    this.getDeviceCommand()
  },
  methods: {
    // 根据入口给菜单栏 device.vue进入隐藏SOS/蓝牙/室内定位/通讯录设置；deviceTest.vue不隐藏
    getTabs () {
      let vm = this
      if (this.deviceRow.devicetype === 901 || this.deviceRow.devicetype === 903) {
        if (this.listObj.test) {
          vm.tabs = [
            {index: 0, name: 'SOS呼叫号码'},
            {index: 1, name: '跌倒设置'},
            {index: 2, name: '闹钟提醒'},
            {index: 3, name: '语音设置'},
            {index: 4, name: '蓝牙功能'},
            {index: 5, name: '定位设置'},
            {index: 6, name: '室内定位'},
            {index: 7, name: '录音上传'},
            {index: 8, name: '通讯录设置'},
            {index: 9, name: '定位'}
          ]
          vm.indexActive = 0
        } else {
          vm.tabs = [
            {index: 0, name: 'SOS呼叫号码'},
            {index: 2, name: '闹钟提醒'},
            {index: 3, name: '语音设置'},
            {index: 5, name: '定位设置'},
            {index: 7, name: '录音上传'},
            {index: 8, name: '通讯录设置'}
          ]
          vm.indexActive = 0
        }
      }
    },
    // 录音上传
    getRecordByDid () {
      if (this.amr !== null) {
        if (this.amr.isPlaying()) {
          this.amr.stop()
        }
        this.amr = null
      }
      let data = {
        did: this.deviceRow.id,
        imei: this.deviceRow.deviceid
      }
      querydevicerecord(data).then(res => {
        this.recordTable = res.data
        this.recordTable.forEach(function (record) {
          record['isRecord'] = false
        })
      })
    },
    playRecord (row) {
      let vm = this
      if (row.name !== null && row.name !== '') {
        if (vm.amr !== null) {
          if (vm.amr.isPlaying()) {
            vm.amr.stop()
          }
          vm.amr = null
        }
        vm.amr = new BenzAMRRecorder()
        let url = window.location.protocol + '//' + window.location.host + '/audio/' + row.name + '.amr'
        vm.amr.initWithUrl(url).then(function () {
          vm.amr.play()
          row.isRecord = true
          vm.recordTable.forEach(function (record) {
            if (record.id !== row.id) {
              record.isRecord = false
            }
          })
          vm.$nextTick(() => {
            vm.$refs.table.setCurrentRow(null)
          })
        })
        vm.amr.onEnded(function () {
          row.isRecord = false
          vm.$nextTick(() => {
            vm.$refs.table.setCurrentRow(null)
          })
        })
      }
    },
    stopRecord (row) {
      if (this.amr !== null) {
        this.amr.stop()
        this.amr = null
        row.isRecord = false
        this.$nextTick(() => {
          this.$refs.table.setCurrentRow(null)
        })
      }
    },
    // 语音通知
    getVoiceByDid () {
      let data = {
        did: this.deviceRow.id
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryvoicemessagestatusbydid(data, params).then(res => {
        this.totalCells = res.data.cnt
        this.fallDownTable = res.data.voicemessagestatus
      }).catch(() => {})
    },
    showReadTm (row) {
      const stime = Date.parse(new Date(row.push_tm))
      const etime = Date.parse(new Date(row.read_tm))
      const usedTime = etime - stime
      if (usedTime > 0) {
        return row.read_tm
      } else {
        return ''
      }
    },
    showClockPeriod (row) {
      let result = ''
      if (row.period === 'y') {
        result = '按年'
      } else if (row.period === 'm') {
        result = '按月'
      } else if (row.period === 'd') {
        result = '按天'
      } else if (row.period === 's') {
        result = '只提醒一次'
      } else {
        result = row.period
      }
      return result
    },
    showClockContent (row) {
      let result = ''
      if (row.type === 'pill') {
        result = '吃药提醒'
      } else if (row.type === 'BP') {
        result = '量血压'
      } else if (row.type === 'Temp') {
        result = '测体温'
      } else if (row.type === 'GLU') {
        result = '测血糖'
      } else if (row.type === 'PE') {
        result = '体检'
      } else {
        result = row.content
      }
      return result
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getVoiceByDid()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getVoiceByDid()
    },
    addOpen () {
      if (this.indexActive === 8) {
        if (this.phoneList.length < 7) {
          this.addEditPhoneTitle = '添加联系人'
          this.addEditPhoneObj.isAdd = true
          this.addEditPhoneShow = true
        } else {
          this.$notify({
            title: '警告',
            type: 'warning',
            message: '当前最多添加7个联系人'
          })
        }
      } else if (this.indexActive === 2) {
        if (this.clockList.length < 7) {
          this.addEditClockTitle = '添加闹钟'
          this.addEditClockObj.isAdd = true
          this.addEditClockShow = true
        } else {
          this.$notify({
            title: '警告',
            type: 'warning',
            message: '当前最多添加7个闹钟提醒'
          })
        }
      } else if (this.indexActive === 9) {
        this.$refs.locationRef.addLocation()
      }
    },
    editClock (item) {
      this.addEditClockTitle = '编辑闹钟'
      this.addEditClockObj.isAdd = false
      this.addEditClockObj.row = item
      this.addEditClockShow = true
    },
    delClock (item) {
      this.clockList.splice(item.no, 1)
      for (let i = 0; i < this.clockList.length; i++) {
        this.clockList[i].no = i
      }
    },
    getDeviceClock (item) {
      let vm = this
      if (item.no !== null && item.no !== '') {
        let obj = vm.clockList.find(element => element.no === item.no)
        obj.content = item.content
        obj.period = item.period
        obj.time = item.time
        obj.type = item.type
      } else {
        item.no = vm.clockList.length
        vm.clockList.push(item)
      }
    },
    editPhone (item) {
      this.addEditPhoneTitle = '编辑联系人'
      this.addEditPhoneObj.isAdd = false
      this.addEditPhoneObj.row = item
      this.addEditPhoneShow = true
    },
    delPhone (item) {
      this.phoneList.splice(item.no, 1)
      for (let i = 0; i < this.phoneList.length; i++) {
        this.phoneList[i].no = i
      }
    },
    getSrcUri (uri) {
      let url = 'static/head.png'
      let arr = ['.png', '.jpg', '.jpeg']
      for (let i = 0; i < arr.length; i++) {
        if (uri.includes(arr[i])) {
          url = uri
        }
      }
      return url
    },
    getDevicePhoneBook (item) {
      let vm = this
      if (item.no !== null && item.no !== '') {
        let obj = vm.phoneList.find(element => element.no === item.no)
        obj.phone = item.phone
        obj.name = item.name
        obj.uri = item.uri
        obj.im_num = item.im_num
      } else {
        item.no = vm.phoneList.length
        vm.phoneList.push(item)
      }
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitSOSphone () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'community',
        command1: this.sosPhone.phone1 !== '' ? this.sosPhone.phone1 : '',
        command2: this.sosPhone.phone2 !== '' ? this.sosPhone.phone2 : '',
        command3: this.sosPhone.phone3 !== '' ? this.sosPhone.phone3 : '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置SOS呼叫号码',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitFallDown () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'falldown',
        command1: this.fallDownRadio + '',
        command2: this.fallDown !== '' ? this.fallDown + '' : '',
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitAlarmClock () {
      let vm = this
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'setclocks',
        command1: '',
        command2: '',
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      if (vm.clockList.length !== 0) {
        if (vm.clockList[0] !== null && vm.clockList[0] !== undefined) {
          let obj = vm.clockList[0]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.command1 = period + '|' + time + '|' + content
        }
        if (vm.clockList[1] !== null && vm.clockList[1] !== undefined) {
          let obj = vm.clockList[1]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.command2 = period + '|' + time + '|' + content
        }
        if (vm.clockList[2] !== null && vm.clockList[2] !== undefined) {
          let obj = vm.clockList[2]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.command3 = period + '|' + time + '|' + content
        }
        if (vm.clockList[3] !== null && vm.clockList[3] !== undefined) {
          let obj = vm.clockList[3]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.command4 = period + '|' + time + '|' + content
        }
        if (vm.clockList[4] !== null && vm.clockList[4] !== undefined) {
          let obj = vm.clockList[4]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.command5 = period + '|' + time + '|' + content
        }
        if (vm.clockList[5] !== null && vm.clockList[5] !== undefined) {
          let obj = vm.clockList[5]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.reserved1 = period + '|' + time + '|' + content
        }
        if (vm.clockList[6] !== null && vm.clockList[6] !== undefined) {
          let obj = vm.clockList[6]
          let period = obj.period
          let time = obj.time
          let content = obj.content
          data.reserved2 = period + '|' + time + '|' + content
        }
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitVoice () {
      let data = {
        imei: this.deviceRow.deviceid,
        title: this.voiceForm.title + '',
        text: this.voiceForm.text,
        push_type: this.voiceForm.push_type, // 1 组织批量 2 指定设备 3 小区批量 4家庭批量 5指定条件(按人群)
        push_mqtttopic: this.voiceForm.push_mqtttopic,
        oid: parseInt(this.voiceForm.oid), // push_type =1 要有值
        did: parseInt(this.voiceForm.did), // push_type =2 要有值
        cid: parseInt(this.voiceForm.cid), // push_type =3 要有值
        hid: parseInt(this.voiceForm.hid), // push_type =4 要有值
        device_type: this.voiceForm.device_type, // 设备类型，必填，默认700
        person_expand: 0, // 扩展功能  int 0不开启；1开启
        person_sex: this.sendPersonSex,
        person_birthday_from: '',
        person_birthday_to: ''
      }
      if (this.sendPersonSex.length !== 0 || this.sendPersonBirthday !== '') {
        data.push_type = 5
        data.person_expand = 1
      }
      if (data.person_expand === 1) { // 开启扩展功能 两者必填
        if (this.sendPersonBirthday === '') {
          // eslint-disable-next-line no-extend-native
          Date.prototype.format = this.validate.format
          let day = new Date().format('yyyyMMdd')
          data.person_birthday_from = '19000101'
          data.person_birthday_to = day
        }
        if (this.sendPersonSex.length === 0) {
          data.person_sex = [0, 1]
        }
      }
      // console.log(data)
      addvoicemsg(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功添加语音通知',
          type: 'success',
          duration: 2000
        })
        this.getVoiceByDid()
      }).catch(() => {})
    },
    submitBluetooth () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'bluetoothswitch',
        command1: this.bluetooth + '',
        command2: this.bluetoothObj.interval + '',
        command3: this.bluetoothObj.time + '',
        command4: this.bluetoothObj.filtration + '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    changeTime (val) {
      this.locationObj.time = val
    },
    submitLocation () {
      // console.log(this.locationObj.timeDate)
      // return
      // locationRadio
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: '',
        command1: '',
        command2: '',
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      if (this.locationRadio === '1') {
        // 按次定位
        data.method = 'requirelocation'
        data.command1 = this.location1 + ''
        data.command2 = this.locationObj.num !== '' ? this.locationObj.num + '' : ''
        data.command3 = this.locationObj.time !== '' ? this.locationObj.time + '' : ''
        data.command4 = this.locationObj.selectModel !== '' ? this.locationObj.selectModel + '' : ''
      } else {
        // 按时间断定位
        data.method = 'requirelocationperiod'
        data.command1 = this.location2 + ''
        data.command2 = this.locationObj.timeDate[0] ? this.locationObj.timeDate[0] : ''
        data.command3 = this.locationObj.timeDate[1] ? this.locationObj.timeDate[1] : ''
        data.command4 = this.locationObj.time !== '' ? this.locationObj.time + '' : ''
        data.command5 = this.locationObj.selectModel !== '' ? this.locationObj.selectModel + '' : ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitIndoor () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'requirelocationinroom',
        command1: this.indoorObj.model !== '' ? this.indoorObj.model + '' : '',
        command2: this.indoorObj.type !== '' ? this.indoorObj.type + '' : '',
        command3: this.indoorObj.symbol !== '' ? this.indoorObj.symbol : '',
        command4: this.indoorObj.interval !== '' ? this.indoorObj.interval : '',
        command5: this.indoorObj.time !== '' ? this.indoorObj.time : '',
        reserved1: this.indoor + '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitRecord () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'recordvoice',
        command1: '',
        command2: '',
        command3: this.recordObj.duration,
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
        this.getRecordByDid()
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '设置设备失败'
        })
      })
    },
    submitPhoneBook () {
      let vm = this
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'phonebook',
        command1: '',
        command2: '',
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      if (vm.phoneList.length !== 0) {
        if (vm.phoneList[0] !== null && vm.phoneList[0] !== undefined) {
          let obj = vm.phoneList[0]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.command1 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[1] !== null && vm.phoneList[1] !== undefined) {
          let obj = vm.phoneList[1]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.command2 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[2] !== null && vm.phoneList[2] !== undefined) {
          let obj = vm.phoneList[2]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.command3 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[3] !== null && vm.phoneList[3] !== undefined) {
          let obj = vm.phoneList[3]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.command4 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[4] !== null && vm.phoneList[4] !== undefined) {
          let obj = vm.phoneList[4]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.command5 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[5] !== null && vm.phoneList[5] !== undefined) {
          let obj = vm.phoneList[5]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.reserved1 = name + '|' + phone + '|' + url + '|' + imNum
        }
        if (vm.phoneList[6] !== null && vm.phoneList[6] !== undefined) {
          let obj = vm.phoneList[6]
          let name = obj.name
          let phone = obj.phone
          let url = obj.uri !== '' ? obj.uri : 'http://baidu.com'
          let imNum = obj.im_num !== '' ? obj.im_num : '112'
          data.reserved2 = name + '|' + phone + '|' + url + '|' + imNum
        }
      }
      sendcommand(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功设置设备',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {})
    },
    getDeviceCommand () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id
      }
      querycommand(data).then(res => {
        let vm = this
        let resDatas = res.data
        if (resDatas !== null) {
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            if (key === 'deviceset') {
            } else {
              let value = JSON.parse(resData.value)
              if (key === 'community') {
                vm.sosPhone.phone1 = value.command1
                vm.sosPhone.phone2 = value.command2
                vm.sosPhone.phone3 = value.command3
              } else if (key === 'falldown') {
                vm.fallDownRadio = parseInt(value.command1)
                vm.fallDown = value.command2
              } else if (key === 'bluetoothswitch') {
                vm.bluetooth = parseInt(value.command1)
                vm.bluetoothObj.interval = value.command2
                vm.bluetoothObj.time = value.command3
                vm.bluetoothObj.filtration = value.command4
              } else if (key === 'requirelocation') {
                vm.location1 = parseInt(value.command1)
                vm.locationObj.num = value.command2
                vm.locationObj.time = value.command3
                vm.time = value.command3
                vm.locationObj.selectModel = value.command4 !== '' ? parseInt(value.command4) : ''
              } else if (key === 'requirelocationperiod') {
                vm.location2 = parseInt(value.command1)
                vm.locationObj.timeDate = [value.command2, value.command3]
                vm.locationObj.time = value.command4
                vm.time = value.command4
                vm.locationObj.selectModel = value.command5 !== '' ? parseInt(value.command5) : ''
              } else if (key === 'requirelocationinroom') {
                vm.indoor = parseInt(value.reserved1)
                vm.indoorObj.model = parseInt(value.command1)
                vm.indoorObj.type = parseInt(value.command2)
                vm.indoorObj.symbol = value.command3
                vm.indoorObj.interval = value.command4
                vm.indoorObj.time = value.command5
              } else if (key === 'recordvoice') {
                vm.recordObj.url = value.command1
                vm.recordObj.fileName = value.command2
                vm.recordObj.duration = value.command3
              } else if (key === 'setclocks') {
                if (value.command1 !== null && value.command1 !== undefined && value.command1 !== '') {
                  let strArr = value.command1.split('|')
                  let obj = {
                    no: 0,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.command2 !== null && value.command2 !== undefined && value.command2 !== '') {
                  let strArr = value.command2.split('|')
                  let obj = {
                    no: 1,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.command3 !== null && value.command3 !== undefined && value.command3 !== '') {
                  let strArr = value.command3.split('|')
                  let obj = {
                    no: 2,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.command4 !== null && value.command4 !== undefined && value.command4 !== '') {
                  let strArr = value.command4.split('|')
                  let obj = {
                    no: 3,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.command5 !== null && value.command5 !== undefined && value.command5 !== '') {
                  let strArr = value.command5.split('|')
                  let obj = {
                    no: 4,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.reserved1 !== null && value.reserved1 !== undefined && value.reserved1 !== '') {
                  let strArr = value.reserved1.split('|')
                  let obj = {
                    no: 5,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
                if (value.reserved2 !== null && value.reserved2 !== undefined && value.reserved2 !== '') {
                  let strArr = value.reserved2.split('|')
                  let obj = {
                    no: 6,
                    period: strArr[0],
                    time: strArr[1],
                    content: strArr[2],
                    type: ''
                  }
                  if (obj.content === 'pill' || obj.content === 'BP' || obj.content === 'Temp' || obj.content === 'GLU' || obj.content === 'PE') {
                    obj.type = obj.content
                  } else {
                    obj.type = 'other'
                  }
                  vm.clockList.push(obj)
                }
              } else if (key === 'phonebook') {
                if (value.command1 !== null && value.command1 !== undefined && value.command1 !== '') {
                  let strArr = value.command1.split('|')
                  let obj = {
                    no: 0,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.command2 !== null && value.command2 !== undefined && value.command2 !== '') {
                  let strArr = value.command2.split('|')
                  let obj = {
                    no: 1,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.command3 !== null && value.command3 !== undefined && value.command3 !== '') {
                  let strArr = value.command3.split('|')
                  let obj = {
                    no: 2,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.command4 !== null && value.command4 !== undefined && value.command4 !== '') {
                  let strArr = value.command4.split('|')
                  let obj = {
                    no: 3,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.command5 !== null && value.command5 !== undefined && value.command5 !== '') {
                  let strArr = value.command5.split('|')
                  let obj = {
                    no: 4,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.reserved1 !== null && value.reserved1 !== undefined && value.reserved1 !== '') {
                  let strArr = value.reserved1.split('|')
                  let obj = {
                    no: 5,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
                if (value.reserved2 !== null && value.reserved2 !== undefined && value.reserved2 !== '') {
                  let strArr = value.reserved2.split('|')
                  let obj = {
                    no: 6,
                    name: strArr[0],
                    phone: strArr[1],
                    uri: strArr[2] === 'http://baidu.com' ? '' : strArr[2],
                    im_num: strArr[3] === '112' ? '' : strArr[3]
                  }
                  vm.phoneList.push(obj)
                }
              } else if (key === 'requirelocationperiod310') {
                this.locationCommand = value.command1
                if (this.indexActive === 9) {
                  this.$refs.locationRef.getDeviceLocationData(value.command1)
                }
              }
            }
          }
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .sos-phone{
    color: #333333;
    font-size: 16px;
    letter-spacing: 1px;
  }
  .fall-down{
    font-family: SourceHanSansCN-Regular!important;
    letter-spacing: 1px;
    color: #333333;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .box-card{
    height: 100px;
  }
  .box-card:hover{
    background-color: #f2fafa;
    border-radius: 6px;
  }
  .img-left{
    float: left;
    height: 100%;
    width: 100px;
  }
  .img-left img{
    width: 60px;
    height: 60px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .body-center{
    float: left;
    height: 100%;
    width: calc(100% - 370px);
  }
  .body-center img{
    width: 16px;
    height: 16px;
  }
  .btn-right{
    float: right;
    height: 100%;
    width: 260px;
  }
  .del-sub-red{
    cursor: pointer;
    margin-top: 35px;
    width: 100px;
    height: 30px;
    background-image: linear-gradient(0deg, #e50000 0%, #ff7f7f 100%);
    border-radius: 15px;
  }
  .edit-sub-blue{
    cursor: pointer;
    margin-top: 35px;
    width: 100px;
    height: 30px;
    background-image: linear-gradient(0deg, #1786fc 0%, #7ebbfc 100%);
    border-radius: 15px;
  }
  .btn-title-gray{
    font-size: 18px;
    margin-right: 20px;
    float: left;
    width: 160px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px;
    border: solid 1px #cccccc;
  }
  .btn-title-blue{
    font-size: 18px;
    margin-right: 20px;
    float: left;
    width: 160px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background-color: rgba(22, 132, 252, 0.05);
    border-radius: 18px;
    border: solid 1px #1684fc;
  }
  .up-record{
    cursor: pointer;
    font-size: 18px;
    margin-right: 10px;
    color: #ffffff;
    float: left;
    width: 160px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background-color: rgba(22, 132, 252, 1);
    border-radius: 18px;
    border: solid 1px #1684fc;
  }
  .content-info{
    margin: 0 30px;
    height: 500px;
    overflow-y: auto;
    background-color: #FFFFFF;
  }

  .line-btn{
    height: 60px;
    background: #F2F2F2;
    border-radius: 6px 6px 6px 6px;
    margin: 0px 30px 0;
    display: flex;
  }
  .btn-name{
    height: 60px;
    line-height: 60px;
    font-weight: 400;
    font-size: 22px;
    color: #1A1A1A;
    letter-spacing: 6px;
    padding: 0 30px;
  }
  .btn-text{
    height: 60px;
    line-height: 60px;
    font-weight: 400;
    font-size: 22px;
    color: #9FA2AA;
    flex: 1;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    white-space: nowrap;
  }
  .btn-arrow{
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/listTabsCat.vue